import { gql, useApolloClient, useQuery } from '@apollo/client';
import {
  GetRawArticleQuery,
  GetRawArticleQueryVariables,
} from '../../../__generated__/queries-topic';
import {
  RAW_ARTICLE_VERSION_FRAGMENT,
  ASSIGMENT_FRAGMENT,
} from './articleEditFragments.topic.graphql';

export const GET_RAW_ARTICLE_QUERY = gql`
  query GetRawArticle($id: UUID!, $versionId: UUID!) {
    rawArticle(where: { id: $id }) {
      id
      assignment {
        ...AssignmentFragment
      }
      versions(first: 10, where: { id: $versionId }) {
        ...ArticleForm_RawArticleVersionFragment
      }
    }
  }
  ${RAW_ARTICLE_VERSION_FRAGMENT}
  ${ASSIGMENT_FRAGMENT}
`;

export const useGetRawArticle = (id: string, versionId: string) =>
  useQuery<GetRawArticleQuery, GetRawArticleQueryVariables>(
    GET_RAW_ARTICLE_QUERY,
    {
      variables: { id, versionId },
      skip: !id || !versionId,
    },
  );

export const useRawArticleGetter = () => {
  const client = useApolloClient();

  return (id: string, versionId: string) =>
    client.query<GetRawArticleQuery, GetRawArticleQueryVariables>({
      query: GET_RAW_ARTICLE_QUERY,
      variables: {
        id,
        versionId,
      },
    });
};
